import { createContext } from 'react';

var TabsContext = /*#__PURE__*/createContext({
  activeTab: '',
  tabType: 'primary',
  noVertical: false,
  deregister: function deregister(tab) {},
  register: function register(name, tab) {},
  setActiveTab: function setActiveTab(name) {},
  setTabs: function setTabs() {},
  tabs: {}
});

export default TabsContext;
